
<a
  href="#"
  [class]="'cp-button bt-size-' + size"

  nz-button
  nz-popover
  [nzPopoverContent]="contentTemplate"
  (click)="$event.preventDefault()"
  >
  <!--
  nzPopoverTrigger="click" -->

  @for (style of defaultStyles; track style) {
    <span
      [class]="'cp-style ' + style"
    ></span>
  }

</a>



<ng-template #contentTemplate>
  <div class="colors">

    <div
      [class]="'box-style bts-none'"
      [class.selected]="style == 'bts-none'"
      (click)="onClick('bts-none')"
    ></div>

    @for (item of presets; track item) {
      <div
        [class]="'box-style ' + item"
        [class.selected]="style == item"
        (click)="onClick(item)"
      ></div>
    }
  </div>
  <div class="pull-clear"></div>
</ng-template>
